<template>
  <div class="box">
    <div class="main-content">
      <div class="exerciseReview-top flex align justify">
        <img class="pointer" @click="reviewByQuestion"
          :src="reviewType == 'question' ? require('@/assets/courseTeaching/checkReviewByQuestion.png') : require('@/assets/courseTeaching/unCheckReviewByQuestion.png')" />
        <div class="separate"></div>
        <img class="pointer" @click="reviewByPerson"
          :src="reviewType == 'person' ? require('@/assets/courseTeaching/checkReviewByPerson.png') : require('@/assets/courseTeaching/unCheckReviewByPerson.png')" />
      </div>
      <!-- 按题批阅部分开始 -->
      <div v-show="reviewType == 'question'" class="reviewByQuestion-content">
        <!-- 选择器部分开始 -->
        <div class="flex" style="padding-left: 40px; box-sizing: border-box">
          <!-- 班级选择器 -->
          <div class="flex align">
            <div class="selector-txt">班级</div>
            <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
          </div>
          <!-- 课次选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">课次</div>
            <el-select @change="classTimesHandleChange" v-model="classNumberValue" placeholder="请选择">
              <el-option v-for="item in classNumberOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 选择器部分结束 -->
        <!-- 习题列表部分开始 -->
        <div style="height: 703px; overflow: scroll">
          <div class="exercisesList" v-for="(item, index) in exercisesList" :key="index">
            <!-- 题干 -->
            <div class="flex align spaceBetween">
              <div class="flex align">
                <div class="topicType">{{ item.types }}</div>
                <div class="questionNo">{{ index + 1 }}.</div>
                <div class="stem">{{ item.content }}</div>
              </div>
              <div class="flex align">
                <div class="score-txt">分值:</div>
                <div class="score-inputFrame flex justify">
                  <input v-model="item.score" disabled class="score-input" type="text" />
                </div>
                <img @click="reviewByQuestionDetail(item.types, item.id)" style="margin-left: 30px; cursor: pointer"
                  src="@/assets/courseTeaching/iconDetail.png" />
              </div>
            </div>
            <div class="flex spaceBetween">
              <div style="width: 75%">
                <!-- 选项 -->
                <div v-if="item.types != '简答题'" class="exampleList-option">
                  <div v-for="(item, index) in item.options" :key="index">
                    <div class="exampleList-option-txt">{{ optionOrder[index] }}.{{ item }}</div>
                  </div>
                </div>
                <!-- 答案 -->
                <div v-if="item.types != '简答题'" class="answer flex align" style="margin-left: 85px; margin-top: 16px">
                  <div class="answer-txt">答案:</div>
                  <div class="answer-English">{{ item.answer.toString().replaceAll(",", "、") }}</div>
                </div>
                <!-- 解析 -->
                <div class="flex" style="margin-left: 85px; margin-top: 16px">
                  <div class="answer-txt">解析:</div>
                  <div class="answer-English">{{ item.comment }}</div>
                </div>
              </div>
              <echartsPie v-if="item.types != '简答题'" ref="echartsPie1" :preData="item.preData[0]"></echartsPie>
            </div>
          </div>
        </div>
        <!-- 习题列表部分结束 -->
      </div>
      <!-- 按题批阅部分结束 -->
      <!-- 按人批阅部分开始 -->
      <div v-show="reviewType == 'person'" class="reviewByPerson-content">
        <!-- 学生数据表格部分开始 -->
        <div v-show="whetherTable == true" style="padding: 0 40px 0 40px; box-sizing: border-box">
          <!-- 选择器部分开始 -->
          <div class="flex" style="margin-bottom: 20px">
            <!-- 班级选择器 -->
            <div class="flex align">
              <div class="selector-txt">班级</div>
              <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
            </div>
            <!-- 课次选择器 -->
            <div class="flex align" style="margin-left: 50px">
              <div class="selector-txt">课次</div>
              <el-select @change="classTimesHandleChange" v-model="classNumberValue" placeholder="请选择">
                <el-option v-for="item in classNumberOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 选择器部分结束 -->
          <el-table :data="studentDataList" :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe
            border height="650">
            <el-table-column align="center" prop="name" label="学生姓名"> </el-table-column>
            <el-table-column align="center" prop="account" label="学号"> </el-table-column>
            <el-table-column align="center" prop="grade" label="年级"> </el-table-column>
            <el-table-column align="center" prop="class" label="班级"> </el-table-column>
            <el-table-column align="center" prop="updated" label="提交时间"> </el-table-column>
            <el-table-column align="center" prop="completionDegree" label="完成度">
              <template slot-scope="scope">
                <el-progress define-back-color="#cccccc" color="#129B36"
                  :percentage="scope.row.completionDegree"></el-progress>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="查看详情">
              <template slot-scope="scope">
                <div @click="reviewByPersonDetail(scope.row.id)" class="detail pointer">查看详情</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 学生数据表格部分结束 -->
        <!-- 学生详情部分开始 -->
        <div v-show="whetherTable == false">
          <!-- 选择器部分开始 -->
          <div class="flex" style="padding-left: 40px; box-sizing: border-box">
            <!-- 班级选择器 -->
            <div class="flex align">
              <div class="selector-txt">班级</div>
              <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
            </div>
            <!-- 姓名选择器 -->
            <div class="flex align" style="margin-left: 50px">
              <div class="selector-txt">姓名</div>
              <el-select @change="nameHandleChange" v-model="nameValue" placeholder="请选择">
                <el-option v-for="item in nameOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!-- 课次选择器 -->
            <div class="flex align" style="margin-left: 50px">
              <div class="selector-txt">课次</div>
              <el-select @change="classTimesHandleChange" v-model="classNumberValue" placeholder="请选择">
                <el-option v-for="item in classNumberOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="height: 703px; overflow: scroll">
            <div class="exercisesList" v-for="(item, index) in exercisesList" :key="index">
              <!-- 题干 -->
              <div class="flex align spaceBetween">
                <div class="flex align">
                  <div class="topicType">{{ item.types }}</div>
                  <div class="questionNo">{{ index + 1 }}.</div>
                  <div class="stem">{{ item.content }}</div>
                </div>
                <div class="flex align">
                  <div class="score-txt">分值:</div>
                  <div class="score-inputFrame flex justify">
                    <input v-model="item.score" :disabled="item.types != '简答题' ? true : false" class="score-input"
                      type="text" />
                  </div>
                  <div @click="scoreModification(item.link_resource_id, item.score)" v-if="item.types == '简答题'"
                    class="answer-txt pointer" style="margin-left: 20px">修改</div>
                </div>
              </div>
              <div class="flex spaceBetween">
                <div style="width: 75%">
                  <!-- 选项 -->
                  <div v-if="item.types != '简答题'" class="exampleList-option">
                    <div v-for="(item, index) in item.options" :key="index">
                      <div class="exampleList-option-txt">{{ optionOrder[index] }}.{{ item }}</div>
                    </div>
                  </div>
                  <!-- 答案 -->
                  <div v-if="item.types != '简答题'" class="answer flex align" style="margin-left: 85px; margin-top: 16px">
                    <div class="answer-txt">答案:</div>
                    <div class="answer-English">{{ item.answer.toString().replaceAll(",", "、") }}</div>
                  </div>
                  <!-- 学生答案 -->
                  <div class="answer flex align" style="margin-left: 85px; margin-top: 16px">
                    <div class="answer-txt" style="width: auto">学生答案:</div>
                    <div class="answer-English">{{ item.studentAnswer }}</div>
                  </div>
                  <!-- 解析 -->
                  <div class="flex" style="margin-left: 85px; margin-top: 16px">
                    <div class="answer-txt">解析:</div>
                    <div class="answer-English">{{ item.comment }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 学生详情部分结束 -->
      </div>
      <!-- 按人批阅部分结束 -->
    </div>
    <!-- 查看数据表格弹窗 -->
    <div v-show="showViewData" class="popup-viewData flex align justify">
      <img @click="showViewData = false" class="btnClose pointer" src="../../assets/btnClose.png" />
      <div class="viewData-content flex align justify">
        <el-table :data="studentDataList" :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe border
          height="calc(100vh - 1.8rem)">
          <el-table-column align="center" prop="name" label="学生姓名"> </el-table-column>
          <el-table-column align="center" prop="account" label="学号"> </el-table-column>
          <el-table-column align="center" prop="grade" label="年级"> </el-table-column>
          <el-table-column align="center" prop="class" label="班级"> </el-table-column>
          <el-table-column align="center" prop="updated" label="提交时间"> </el-table-column>
          <el-table-column align="center" prop="submitAnswers" label="提交答案"> </el-table-column>
          <el-table-column v-if="whetherAnswer == false" align="center" prop="isItCorrect" label="是否正确">
          </el-table-column>
          <el-table-column v-if="whetherAnswer == true" align="center" prop="score" label="得分">
            <template slot-scope="scope">
              <el-input-number size="small" v-model="scope.row.score" @change="answerHandleChange" :min="0" :max="100"
                label="描述文字"
                :disabled="scope.row.submitAnswers == '未答题' || scope.row.submitAnswers == '' ? true : false"></el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { classCascade, courseLearningRecords, learningRecordsModification } from "@/api";
import echartsPie from "@/components/echarts_pie";
import { Toast } from "vant";
export default {
  data() {
    return {
      reviewType: "question", // 批阅类型 按题question 按人person
      classOptions: [], // 班级选项
      classValue: ["2021级", 1], // 默认班级
      classNumberOptions: [], // 课次选项
      classNumberValue: 0, // 默认课次
      nameOptions: [], // 姓名选项
      nameValue: "", // 默认姓名
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      exercisesList: [], // 题目列表
      studentDataList: [], // 学生表格数据
      answerRecordList: [], // 答题记录数据
      showViewData: false, // 是否展示查看数据弹窗
      whetherAnswer: false, // 是否是简答题不是得分隐藏
      whetherTable: false, // 是否展示按人批阅表格
      totalScore: 0, // 题目总分
      completionDegree: 0, // 完成度
    };
  },
  components: { echartsPie },
  created() {
    // 获取年级班级选择器级联数据
    classCascade().then((res) => {
      this.classValue[0] = res.data.datas[0].grade; // 默认年级班级选择器年级
      this.classValue[1] = res.data.datas[0].class[0].id; // 默认年级班级选择器班级id
      for (let i in res.data.datas) {
        for (let j in res.data.datas[i].class) {
          let publicRes = res.data.datas[i].class;
          publicRes[j].value = publicRes[j].id;
          publicRes[j].label = publicRes[j].name;
        }
        this.classOptions.push({
          value: res.data.datas[i].grade,
          label: res.data.datas[i].grade,
          children: res.data.datas[i].class,
        });
      }
      // 调用获取数据方法
      this.publicGettingDataFunc();
    });
    // 获取当前课程全部课次的数据
    for (let i in this.$store.state.classListRecord) {
      this.classNumberValue = this.$store.state.classListRecord[0].id; // 默认课次选择器课次id
      // 获取课次选择器数据
      this.classNumberOptions.push({
        value: this.$store.state.classListRecord[i].id,
        label: this.$store.state.classListRecord[i].name,
      });
    }
  },
  methods: {
    // 给数组从大到小排序
    sortChange(a, b) {
      return a - b;
    },
    // 判断两个数组是否相等
    isArrayEqual(array1, array2) {
      // 如果两个数组长度不同，那么它们肯定不相等
      if (array1.length !== array2.length) {
        return false;
      }

      // 我们可以使用Array.prototype.every方法来检查每个数组元素是否都相等
      return array1.every(function (value1, index) {
        return value1 === array2[index];
      });
    },
    // 获取数据
    publicGettingDataFunc() {
      this.exercisesList = []; // 清空资源数据
      this.nameOptions = []; // 清空姓名选择器数据
      // this.nameValue = ""; // 重置默认姓名
      this.totalScore = 0; // 清零总分
      let params = { lesson_item_id: this.classNumberValue, class_id: this.classValue[1], types: "examitem" };
      courseLearningRecords(params).then((res) => {
        // // 默认姓名选择器姓名
        // if (res.data.ext.users.length != 0) {
        //   this.nameValue = res.data.ext.users[0].value;
        // }
        // 获取学生表格数据
        let topicLog = {};
        let arrayResult = {};
        for (let i in res.data.datas) {
          let resource_id = res.data.datas[i].resource_id;
          topicLog[resource_id] = [];
          arrayResult[resource_id] = [];
          res.data.datas[i].exam_item.link_resource_id = res.data.datas[i].id;
          let publicRes = res.data.datas[i].exam_item;
          // 获取echart的数据
          publicRes.preData = [];
          publicRes.preData.push({
            typeList: [],
            show: true,
            countLength: "{totalText|正确率}" + "\n" + "{totalText|" + 0 + "%}",
          });
          for (let j in publicRes.options) {
            publicRes.preData[0].typeList.push({
              value: 0,
              name: this.optionOrder[j],
            });
          }
          // 给echarts图表正确率赋值
          publicRes.correctNum = 0;
          for (let j in res.data.ext.lesson_user) {
            if (publicRes.id == res.data.ext.lesson_user[j].resource_id) {
              let answerArr = res.data.ext.lesson_user[j].answer.split(",").filter(Boolean).map(Number);
              let isItCorrect = this.isArrayEqual(publicRes.answer, answerArr.sort(this.sortChange));
              if (isItCorrect) {
                publicRes.correctNum++;
              }
            }
          }
          let accuracy = ((publicRes.correctNum / res.data.ext.users.length) * 100).toFixed(1);
          publicRes.preData[0].countLength = "{totalText|正确率}" + "\n" + "{totalText|" + accuracy + "%}";
          // 题目类型
          if (publicRes.types == "single") {
            publicRes.types = "单选题";
          } else if (publicRes.types == "multi") {
            publicRes.types = "多选题";
          } else if (publicRes.types == "truefalse") {
            publicRes.types = "判断题";
            publicRes.options[0] = "正确";
            publicRes.options[1] = "错误";
          } else if (publicRes.types == "answer") {
            publicRes.types = "简答题";
          }
          // 题干
          publicRes.content = publicRes.content.replace(/<[^>]+>/g, "");
          // 答案
          for (let j = 0; j < publicRes.answer.length; j++) {
            publicRes.answer[j] = this.optionOrder[publicRes.answer[j]]; // 题目答案获取
          }
          // 解析
          publicRes.comment = publicRes.comment.replace(/<[^>]+>/g, "");
          for (let j in res.data.ext.lesson_user) {
            if (publicRes.id == res.data.ext.lesson_user[j].resource_id) {
              // // 初始化echarts图表
              // for (let x in publicRes.options) {
              //   publicRes.preData[0].typeList[x].value = 0;
              // }
              // 获取答题记录
              if (res.data.ext.lesson_user[j].assets_type != "answer") {
                topicLog[resource_id].push(res.data.ext.lesson_user[j].answer);
              }
              let countObj = {};
              let arrayNum = topicLog[resource_id].join(",").split(",").filter(Boolean).map(Number);
              for (let i = 0; i < arrayNum.length; i++) {
                let num = arrayNum[i];
                if (countObj[num]) {
                  // 如果对象中已存在该数，则计数加一
                  countObj[num] += 1;
                } else {
                  // 如果对象中不存在该数，则创建新的键，并设置计数为一
                  countObj[num] = 1;
                }
              }
              // console.log(countObj);
              arrayResult[resource_id] = countObj;
            }
          }
          // 给echarts图表选项赋值
          for (let j in arrayResult) {
            // console.log(arrayResult);
            if (j == publicRes.id) {
              for (let z in arrayResult[j]) {
                // console.log(z);
                if (z !== "-1") {
                  publicRes.preData[0].typeList[z].value = arrayResult[j][z];
                }
              }
            }
          }
          // 题目列表
          this.exercisesList.push(publicRes);
          // 题目总分
          this.totalScore += publicRes.score;
        }
        // 获取学生表格数据
        for (let i in res.data.ext.users) {
          // 获取姓名选择器数据
          this.nameOptions.push({
            value: res.data.ext.users[i].id,
            label: res.data.ext.users[i].name,
          });
          let publicRes = res.data.ext.users[i];
          publicRes.grade = res.data.ext.class.grade; // 获取年级
          publicRes.class = res.data.ext.class.name; // 获取班级
          publicRes.updated = publicRes.updated.substring(0, 10); // 获取提交时间
          publicRes.submitAnswers = "未答题"; // 获取提交答案
          publicRes.score = 0; // 当前的分
          publicRes.scoreEarned = 0; // 当前得分
          publicRes.completionDegree = 0; // 获取完成度
          for (let j in res.data.ext.lesson_user) {
            if (publicRes.account == res.data.ext.lesson_user[j].user_account) {
              publicRes.scoreEarned += res.data.ext.lesson_user[j].score; // 计算当前得分
              publicRes.completionDegree = parseFloat(((publicRes.scoreEarned / this.totalScore) * 100).toFixed(1)); // 计算出保留一位小数的完成度
            }
          }
        }
        this.studentDataList = res.data.ext.users;
        // 获取答题记录列表
        this.answerRecordList = res.data.ext.lesson_user;
        // 获取按人批阅学生答案
        for (let i in this.answerRecordList) {
          if (this.answerRecordList[i].user_id == this.nameValue) {
            for (let j in this.exercisesList) {
              if (this.exercisesList[j].id == this.answerRecordList[i].resource_id) {
                if (this.answerRecordList[i].assets_type == "answer") {
                  this.exercisesList[j].studentAnswer = this.answerRecordList[i].answer;
                } else {
                  this.exercisesList[j].studentAnswer = "";
                  let options = this.answerRecordList[i].answer.split(",");
                  options.sort((a, b) => {
                    return a - b;
                  });
                  options = options.filter(function (s) {
                    return s && s.trim();
                  });
                  // console.log(options);
                  for (let i in options) {
                    this.exercisesList[j].studentAnswer += this.optionOrder[options[i]] + " ";
                  }
                }
              }
            }
          }
        }
      });
    },
    // 按题批阅
    reviewByQuestion() {
      this.reviewType = "question";
      this.whetherTable = true;
    },
    // 按人批阅
    reviewByPerson() {
      this.reviewType = "person";
      this.whetherTable = true;
    },
    // 班级选择器
    classHandleChange(value) {
      this.classValue[1] = value[1]; // 获取班级id
      this.publicGettingDataFunc(); // 调用获取数据方法
    },
    // 课次选择器
    classTimesHandleChange(value) {
      this.classNumberValue = value; // 获取课次id
      this.publicGettingDataFunc(); // 调用获取数据方法
    },
    // 姓名选择器
    nameHandleChange(name) {
      // 清空学生答案数据
      for (let i in this.exercisesList) {
        this.exercisesList[i].studentAnswer = "";
      }
      this.nameValue = name;
      for (let i in this.answerRecordList) {
        if (this.answerRecordList[i].user_id == this.nameValue) {
          for (let j in this.exercisesList) {
            if (this.exercisesList[j].id == this.answerRecordList[i].resource_id) {
              if (this.answerRecordList[i].assets_type == "answer") {
                this.exercisesList[j].studentAnswer = this.answerRecordList[i].answer;
              } else {
                this.exercisesList[j].studentAnswer = "";
                let options = this.answerRecordList[i].answer.split(",");
                options.sort((a, b) => {
                  return a - b;
                });
                options = options.filter(function (s) {
                  return s && s.trim();
                });
                for (let i in options) {
                  this.exercisesList[j].studentAnswer += this.optionOrder[options[i]] + " ";
                }
              }
            }
          }
        }
      }
    },
    // 按题批阅查看详情
    reviewByQuestionDetail(type, resourceId) {
      // 恢复数据
      for (let i in this.studentDataList) {
        this.studentDataList[i].submitAnswers = "未答题";
        this.studentDataList[i].isItCorrect = "";
      }
      this.showViewData = true;
      if (type == "简答题") {
        this.whetherAnswer = true;
      } else {
        this.whetherAnswer = false;
      }
      for (let i in this.answerRecordList) {
        if (this.answerRecordList[i].resource_id == resourceId) {
          for (let j in this.studentDataList) {
            if (this.answerRecordList[i].user_account == this.studentDataList[j].account) {
              // 获取题目答案
              if (this.answerRecordList[i].assets_type == "answer") {
                this.studentDataList[j].submitAnswers = this.answerRecordList[i].answer;
              } else if (this.answerRecordList[i].assets_type == "truefalse") {
                let truefalse = ["正确", "错误"];
                this.studentDataList[j].submitAnswers = truefalse[this.answerRecordList[i].answer];
              } else {
                this.studentDataList[j].submitAnswers = "";
                let options = this.answerRecordList[i].answer.split(",");
                options.sort((a, b) => {
                  return a - b;
                });
                options = options.filter(function (s) {
                  return s && s.trim();
                });
                // console.log(options);
                for (let i in options) {
                  this.studentDataList[j].submitAnswers += this.optionOrder[options[i]] + " ";
                }
              }
              //TODO 获取题目分数接口未调用
              this.studentDataList[j].score = this.answerRecordList[i].score;
              if (this.answerRecordList[i].score != 0) {
                this.studentDataList[j].isItCorrect = "正确";
              } else {
                this.studentDataList[j].isItCorrect = "不正确";
              }
            }
          }
        }
      }
    },
    // 按人批阅查看详情
    reviewByPersonDetail(id) {
      this.whetherTable = false;
      this.nameValue = id;
      for (let i in this.answerRecordList) {
        if (this.answerRecordList[i].user_id == this.nameValue) {
          for (let j in this.exercisesList) {
            if (this.exercisesList[j].id == this.answerRecordList[i].resource_id) {
              if (this.answerRecordList[i].assets_type == "answer") {
                this.exercisesList[j].studentAnswer = this.answerRecordList[i].answer;
              } else {
                this.exercisesList[j].studentAnswer = "";
                let options = this.answerRecordList[i].answer.split(",");
                options.sort((a, b) => {
                  return a - b;
                });
                options = options.filter(function (s) {
                  return s && s.trim();
                });
                for (let i in options) {
                  this.exercisesList[j].studentAnswer += this.optionOrder[options[i]] + " ";
                }
              }
            }
          }
        }
      }
    },
    // 简答题计数器绑定值被改变时触发
    answerHandleChange(value) {
      console.log(value);
    },
    // 题目得分修改
    scoreModification(id, score) {
      let data = {
        link_resource_id: id,
        score: score,
        user_id: this.nameValue,
      };
      learningRecordsModification(data).then((res) => {
        if (res.data.code != 0) {
          Toast(res.data.msg);
        } else {
          Toast("修改成功！");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-content {
  width: 1740px;
  height: 850px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: scroll;
}

.separate {
  margin-left: 40px;
  margin-right: 40px;
  width: 1px;
  height: 40px;
  background: #bfbfbf;
}

.exerciseReview-top {
  width: 100%;
  padding: 23px 0;
  border-bottom: 1px solid #bfbfbf;
}

// 按题批阅
.reviewByQuestion-content {
  width: 100%;
  height: 100%;
  padding: 20px 0 0 0;
  box-sizing: border-box;
}

.selector-txt {
  margin-right: 13px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
}

// 习题列表
.exercisesList {
  padding: 20px 40px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.topicType {
  width: 80px;
  height: 25px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background: #b3cae2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.questionNo {
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 12px;
}

.stem {
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 12px;
}

.exampleList-option {
  margin-top: 15px;
  margin-left: 85px;
  border-left: 4px solid #dddddd;
  padding-left: 15px;
}

.exampleList-option-txt {
  font-size: 14px;

  font-weight: 400;
  color: #000000;
  line-height: 23px;
}

.answer-txt {
  width: 47px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.answer-English {
  width: 90%;
  margin-left: 12px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.score-inputFrame {
  margin-left: 9px;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 5px;
}

.score-input {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 10px;
  text-align: center;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.score-txt {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
}

// 查看数据弹窗
.popup-viewData {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.viewData-content {
  width: 1659px;
  height: 800px;
  border: 1px solid #dddddd;
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}

.btnClose {
  position: absolute;
  top: 24px;
  right: 24px;
}

// 按人批阅
.reviewByPerson-content {
  width: 100%;
  height: 100%;
  padding: 20px 0 0 0;
  box-sizing: border-box;
}

.detail {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}
</style>
